import React from 'react';
import PropTypes from 'prop-types';
import { Navbar} from 'react-bootstrap';
import DragonBall from 'views/atoms/dragonball/DragonBall';

function UserManagementBar({
  screenTitle,
  dragonBall,
}) {

  return (
    <Navbar className="navbar-user-management">
      <Navbar.Brand as="div" className="d-flex align-items-center">
        <div className="page">
          {screenTitle}
          <DragonBall variant="title" icon="far fa-question-circle" stayOpen>
            {dragonBall}
          </DragonBall>
        </div>
      </Navbar.Brand>
    </Navbar>
  );
}

UserManagementBar.propTypes = {
  screenTitle: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  dragonBall: PropTypes.object.isRequired,
};

UserManagementBar.defaultProps = {};

export default UserManagementBar;
